export class PrivateSettingsService {
}
//# sourceMappingURL=settings.js.map